import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { AccountCreateRequest } from 'src/app/services/models/account/account.create.request.model'
import { Response } from 'src/app/services/models/response.model'
import { Account } from './models/account/account.model';
import { AccountUpdateRequest } from './models/account/account.update.request.model';

@Injectable()
export class AccountService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.account;
  }

  createAccount(accountDetail: AccountCreateRequest): Observable<Response<Account>> {
    accountDetail.AccountName = accountDetail.AccountName.trim();
    accountDetail.Email = accountDetail.Email.trim();
    accountDetail.FullName = accountDetail.FullName.trim();
    accountDetail.PhoneNumber = accountDetail.PhoneNumber.trim();
    return this.post(`/CreateAccount`, accountDetail, {})
      .map(result => new Response<Account>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  currentAccount(): Observable<Response<Account>> {
    const url = `/CurrentAccount`;
    return this.get(url)
      .map(result => new Response<Account>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  getAccountInfo(AccountID: number): Observable<Response<Account>> {
    const url = `/GetAccountInfo/` + AccountID;
    return this.get(url)
      .map(result => new Response<Account>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  search(AgentName: string, AccountName: string, FullName: string, Status: number, Address: string, PhoneNumber: string, AccountType: number): Observable<Response<Account[]>> {
    AgentName = AgentName.trim();
    FullName = FullName.trim();
    Address = Address.trim();
    PhoneNumber = PhoneNumber.trim();
    let url = `/SearchAccount?AccountName=${encodeURIComponent(AccountName)}&AgentName=${encodeURIComponent(AgentName)}&FullName=${encodeURIComponent(FullName)}&Address=${encodeURIComponent(Address)}&PhoneNumber=${encodeURIComponent(PhoneNumber)}`;
    if(Status !== -1)
    {
      url = url + `&Status=${Status}`;
    }
    if(AccountType!== -1)
    {
      url = url + `&AccountType=${AccountType}`;      
    }
    return this.get(url)
      .map(result => new Response<Account[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  updateAccountInfo(accountDetail: AccountUpdateRequest): Observable<Response<Account>> {
    accountDetail.Email = accountDetail.Email.trim();
    accountDetail.FullName = accountDetail.FullName.trim();
    accountDetail.PhoneNumber = accountDetail.PhoneNumber.trim();
    return this.post(`/UpdateAccountInfo`, accountDetail, {})
      .map(result => new Response<Account>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }
};